import { render } from "./EventFeatured.vue?vue&type=template&id=2ce1c26f&scoped=true"
import script from "./EventFeatured.vue?vue&type=script&lang=js"
export * from "./EventFeatured.vue?vue&type=script&lang=js"

import "./EventFeatured.vue?vue&type=style&index=0&id=2ce1c26f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce1c26f"]])

export default __exports__